module.exports = __webpack_public_path__ + "static/media/nf.5e07162f.svg";